export enum CollectionStatusEnum {
  HAS_NOT_BEGUN = 'hasn\'t begun',
  IN_PROCESS = 'in Process',
  COMPLETED = 'Completed'
}
